import { brandConfigs } from '@/theme/themeConfig';
import { useBranding as useSharedBranding } from '@gastrosoft/shared/theme';

export const useBranding = () => useSharedBranding(brandConfigs);
